@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
}

.main {
  display: grid;
  grid-template-rows: 1fr max-content max-content;
}
.categories-types-layout {
  grid-template-columns: 1fr 1fr;
}
.api-description-layout {
  padding-block: calc(
    12px * 2
  ); // WA until we define a class for internal spacing.
  display: grid;
  grid-template:
    "api-description-title api-description-title"
    "api-name-label api-name-control"
    "api-description-label api-description-control"
    "api-module-label api-module-control";
  grid-template-columns: max-content 1fr;
}
.api-description-title {
  grid-area: api-description-title;
  padding-block-end: var(--spacing-padding-m);
}
.api-name-label {
  grid-area: api-name-label;
}
.api-name-control {
  grid-area: api-name-control;
}
.api-description-label {
  grid-area: api-description-label;
}
.api-description-control {
  grid-area: api-description-control;
}
.api-module-label {
  grid-area: api-module-label;
}
.api-module-control {
  grid-area: api-module-control;
}
